import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-817f1f72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-0 dialog-content" }
const _hoisted_2 = { class: "field-radiobutton" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "authPartial" }, "Настроить права доступа", -1))
const _hoisted_4 = { class: "field-radiobutton" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "authVK" }, "Полученный при авторизации токен", -1))
const _hoisted_6 = { class: "p-overlay-badge" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle" }, null, -1))
const _hoisted_8 = { class: "flex align-items-center flex-column" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, " Перейдите по желтой ссылке и получите токен доступа. ", -1))
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "w-full mb-3 flex flex-column" }
const _hoisted_12 = { class: "p-error" }
const _hoisted_13 = { class: "flex justify-content-center w-full mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    false
      ? (_openBlock(), _createBlock(_component_Panel, {
          key: 0,
          header: "Выберите вариант привязки",
          toggleable: true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_RadioButton, {
                inputId: "authPartial",
                name: "authType",
                value: "partial",
                modelValue: _ctx.type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_3
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_RadioButton, {
                inputId: "authVK",
                name: "authType",
                value: "auth",
                modelValue: _ctx.type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.type) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_5
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.type === 'partial')
      ? (_openBlock(), _createBlock(_component_Panel, {
          key: 1,
          header: "Выберите разрешения",
          toggleable: true,
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_MultiSelect, {
              class: "w-full",
              modelValue: _ctx.selectedPermissions,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedPermissions) = $event)),
              options: _ctx.permissions,
              optionDisabled: _ctx.disabled,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "Разрешения",
              display: "chip",
              showToggleAll: false
            }, null, 8, ["modelValue", "options", "optionDisabled"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.type === 'partial')
      ? (_openBlock(), _createBlock(_component_Panel, {
          key: 2,
          header: "Получите доступ",
          toggleable: true,
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Button, {
                class: "absolute info-overlay text-blue-400 p-0 p-button-text",
                onClick: _ctx.info
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("a", {
                  class: "p-button p-button-warning p-button-outlined no-underline mb-3",
                  target: "_blank",
                  href: _ctx.getAuthUrl
                }, " Получить токен ", 8, _hoisted_10),
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_InputText, {
                    id: "tokenInput",
                    type: "text",
                    class: _normalizeClass(["w-full", { 'p-invalid': _ctx.error && _ctx.error.length > 0 }]),
                    modelValue: _ctx.token,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.token) = $event)),
                    placeholder: "Полная ссылка или её часть от '=' до '&'",
                    autocomplete: "off",
                    onChange: _ctx.clearError
                  }, null, 8, ["class", "modelValue", "onChange"]),
                  _createElementVNode("small", _hoisted_12, _toDisplayString(_ctx.error), 1)
                ]),
                _createVNode(_component_Button, {
                  label: "Проверить",
                  class: "p-button-info p-button-outlined",
                  loading: _ctx.loading,
                  onClick: _ctx.checkToken
                }, null, 8, ["loading", "onClick"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_Button, {
        label: "Сохранить",
        class: "p-button-success p-button-outlined",
        disabled: !_ctx.success && _ctx.type !== 'auth',
        onClick: _ctx.save
      }, null, 8, ["disabled", "onClick"])
    ])
  ]))
}